import './Project.css'

const Project = ({ project }) => {
  return (
    <div className="container">
      <div className="row mb-5">

        <div className="col-md-4 projectImg">
          <img src={project.img} alt="" className="img-fluid pb-5" data-aos="zoom-in"
            data-aos-duration="500" />
        </div>

        <div className="col-md-8 project-details" data-aos="fade-up"
          data-aos-duration="500">

          <h3 className="project-card__title mt-md-0 mt-sm-5">❖ {project.name}</h3>
          <p style={{ fontSize: '20px', color: 'black', fontFamily: 'NewTimesRoman' }}>{project.description}</p>
          <h3 className="project-card__title mt-md-0 mt-sm-5">❖ Tools & Technology</h3>
          <ul className="tags">{
            project.Technology.map((item) => <li>{item}</li>)
          }</ul>

          <div className="project-link">
            {project?.website &&
              <a href={project.website} target="_blank" rel="noreferrer"><i className="fas fa-globe" /> Live Site</a>}
            {project?.codeLink &&
              <a href={project.codeLink} target="_blank" rel="noreferrer"><i className="fa fa-github" /> Code Link</a>}
            {project?.frontendCode &&
              <a href={project.frontendCode} target="_blank" rel="noreferrer"><i className="fa fa-github" /> Frontend Code</a>}
            {project?.backendCode &&
              <a href={project.backendCode} target="_blank" rel="noreferrer"><i className="fa fa-github" /> Backend Code</a>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;